import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty-state";
import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

import { Button } from "./ui/button";

interface Props {
  title: string;
  icon: LucideIcon;
  description: string;
  cta?: {
    link?: string;
    label: string;
    icon?: LucideIcon;
  };
}

export const EmptyState = ({ title, icon: Icon, description, cta }: Props) => (
  <Empty>
    <EmptyHeader className="gap-0">
      <EmptyMedia variant="default">
        <Icon />
      </EmptyMedia>
      <EmptyTitle className="font-semibold">{title}</EmptyTitle>
      <EmptyDescription>{description}</EmptyDescription>
    </EmptyHeader>
    <EmptyContent>
      {cta && cta.link ? (
        <Button asChild>
          <Link to={cta.link}>
            {cta.icon && <cta.icon className="me-2" />}
            {cta.label}
          </Link>
        </Button>
      ) : null}
    </EmptyContent>
  </Empty>
);
